import { jsxs as f, jsx as t } from "react/jsx-runtime";
import { useTranslation as m } from "../../../hooks/useTranslation/index.js";
import { Colors as s } from "../../../styles/colors/index.js";
import { NotificationBarIconContainer as d, NotificationBadge as B, NotificationBarBellIcon as b } from "./style.js";
import { Bell as p } from "@pelando/fontawesome/icons";
function N({
  onClick: r,
  count: o
}) {
  const { t: e } = m("common"), a = (n) => {
    n.key === " " && (n.preventDefault(), r());
  }, i = !!o, l = o > 9 ? "9+" : o, c = {
    "--borderColor": `rgb(${s.Red})`
  };
  return /* @__PURE__ */ f(
    d,
    {
      onClick: r,
      onKeyDown: a,
      style: i ? c : void 0,
      children: [
        i && /* @__PURE__ */ t(B, { role: "marquee", children: l }),
        /* @__PURE__ */ t(
          b,
          {
            icon: p,
            "aria-label": e("notification-bar-bell-icon")
          }
        )
      ]
    }
  );
}
export {
  N as NotificationBarIcon
};
